import {testIdProps} from '@github-ui/test-id-props'
import {useNamedColor} from '@github-ui/use-named-color'
import {Token, type TokenProps} from '@primer/react'

import type {IssueType} from '../../api/common-contracts'

interface IssueTypeTokenProps extends Omit<TokenProps, 'leadingVisual' | 'text'> {
  issueType: IssueType
  ref?: React.Ref<HTMLElement>
}

export const IssueTypeToken = ({ref, issueType, ...tokenProps}: IssueTypeTokenProps) => {
  const {bg, fg, border} = useNamedColor(issueType.color || 'GRAY')
  return (
    <Token
      text={issueType.name}
      ref={ref}
      style={{backgroundColor: bg, color: fg, borderColor: border}}
      {...tokenProps}
      {...testIdProps(`issue-type-token`)}
    />
  )
}
IssueTypeToken.displayName = 'IssueTypeToken'
